import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { RouteComponent } from 'app/agriculture/router/types';
import { CircularProgress } from '@mui/material';
import { ContentBoxSkeleton } from 'app/agriculture/components/ContentBox/ContentBoxSkeleton';

export function renderRouteComponentWithSuspense({ Component, Skeleton }: RouteComponent) {
    return (
        <SuspenseWrapper
            loadingComponent={!Skeleton ? <DefaultRouteLoadingComponent /> : <Skeleton />}
            ErrorComponent={DefaultRouteErrorComponent}
        >
            <Component />
        </SuspenseWrapper>
    );
}

function DefaultRouteLoadingComponent() {
    return (
        <ContentBoxSkeleton>
            <ContentBox.Section>
                <CircularProgress />
            </ContentBox.Section>
        </ContentBoxSkeleton>
    );
}

function DefaultRouteErrorComponent() {
    return (
        <ContentBoxSkeleton title="Error" Icon={null}>
            <ContentBox.Section>Something went wrong</ContentBox.Section>
        </ContentBoxSkeleton>
    );
}
